import React, { useCallback } from 'react';
import { ActionSheet } from '@kcd/design-system';
import { trackEvent } from '@kcd/event-tracker';

import HorizontalScroll from '~/components/HorizontalScroll';
import { useUpdateRouterQuery } from '~/hooks/url';

import { useDeleteSearchKeywords, useRecentSearchKeywords } from './query';

import { CloseIcon, MoreOutlineIcon } from '~/assets/icons';

export function RecentSearchKeywordList() {
  const [more, setMore] = React.useState(false);
  const [deleteMode, setDeleteMode] = React.useState(false);
  const { data: keywords = [] } = useRecentSearchKeywords();
  const updateRouterQuery = useUpdateRouterQuery();
  const deleteKeywordMutate = useDeleteSearchKeywords();

  const deleteKeyword = useCallback(
    (keyword: string) => {
      void deleteKeywordMutate({
        requestBody: {
          keywords: [keyword],
        },
      });
    },
    [deleteKeywordMutate],
  );

  const deleteAllKeywords = useCallback(() => {
    const allKeywords = keywords.map(({ keyword }) => keyword);
    void deleteKeywordMutate({
      requestBody: {
        keywords: allKeywords,
      },
    });
  }, [deleteKeywordMutate, keywords]);

  const onClickRecentKeyworkd = (keyword: string) => {
    if (deleteMode) {
      deleteKeyword(keyword);
      return;
    }

    trackEvent('clicked tab in 마켓/검색', {
      keyword,
      clicked_area: '최근본상품의연관상품',
    });

    void updateRouterQuery({ searchText: keyword });
  };

  return (
    <div>
      <div className="mb-12 flex justify-between px-20 text-paragraph typo-caption100-regular">
        <h2 className="typo-caption100-semibold">최근 검색어</h2>
        {deleteMode ? (
          <button type="button" onClick={() => setDeleteMode(false)}>
            삭제 완료
          </button>
        ) : (
          <button type="button" onClick={() => setMore(true)}>
            <MoreOutlineIcon width={16} />
          </button>
        )}
      </div>

      <div>
        {keywords?.length === 0 ? (
          <span className="px-20 text-paragraph typo-paragraph100-regular">
            최근 검색어가 없습니다.
          </span>
        ) : (
          <HorizontalScroll gap={8}>
            {keywords.map(({ keyword }) => {
              return (
                <span
                  role="presentation"
                  key={keyword}
                  onClick={() => {
                    void onClickRecentKeyworkd(keyword);
                  }}
                  className="flex items-center rounded-16 border border-solid border-secondary-light px-12 py-[5px] typo-paragraph100-semibold "
                >
                  {keyword}
                  {deleteMode && <CloseIcon className="ml-4 w-16" />}
                </span>
              );
            })}
          </HorizontalScroll>
        )}
      </div>

      <ActionSheet
        onClose={() => setMore(false)}
        opened={more}
        hideCancel
        actions={[
          {
            label: '선택 삭제',
            onClick: () => setDeleteMode(true),
          },
          {
            label: '전체 삭제',
            onClick: deleteAllKeywords,
          },
        ]}
      />
    </div>
  );
}
